export default "__VITE_ASSET__DFxJycu4__"